// Analytics constants for tracking events

export const SHARE_DESTINATION_MAP = {
  facebook: 'Facebook',
  twitter: 'Twitter',
  whatsapp: 'WhatsApp',
  telegram: 'Telegram',
  linkedin: 'LinkedIn',
} as const;

export const SHARE_DESTINATIONS = {
  FACEBOOK: 'Facebook',
  TWITTER: 'Twitter',
  WHATSAPP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  LINKEDIN: 'LinkedIn',
  INSTAGRAM: 'Instagram',
  COPY_LINK: 'Copy Link',
  NATIVE_SHARE: 'Native Share',
} as const;

export const SESSION_COMPLETION_STATUS = {
  USER_CLOSED: 'User Closed',
  ERROR: 'Error',
  TIMEOUT: 'Timeout',
  COMPLETED: 'Completed',
} as const;

export type SessionCompletionStatus =
  (typeof SESSION_COMPLETION_STATUS)[keyof typeof SESSION_COMPLETION_STATUS];

